import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchMrdMonitoringReportsAllIssues = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdMonitoringReportsAllMRDs',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      filter: 'AllIssues',
    },
  });
  return axios.get(serviceURL, payload);
};
